import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialLocalizacaoService {

  private _Url = environment.UrlPrincipal + '/api/materiallocalizacao';

  constructor(private http: HttpClient) {}

  list(inativos) {
    return this.http.get(this._Url + '?inativos=' + inativos)
                    .catch(this.handleError);
  }

  find(id, historico) {
    return this.http.get(this._Url + '/' + id + '?historico=' + historico)
                    .catch(this.handleError);
  }

  save(dados, codigo): Observable<any> {
    let http;
    if (codigo) {
        http = this.http.put(this._Url + '/' + codigo, dados);
    } else {
        http = this.http.post(this._Url, dados);
    }
    http.map((res) => {
        return res;
    }).catch(this.handleError);
    return http;
  }

  private handleError(error: Response) {
    return error.json();
  }

}
